<!-- ===== A) HEADER ===== -->
<div class="financeiro-header">
  <div class="header-left">
    <h4 class="page-title">
      <i class="fe-bar-chart-2"></i>
      Financeiro {{this.balcao ? 'Balcão' : ''}}
    </h4>
    <p class="page-subtitle">Visão geral de vendas e receita</p>
  </div>
</div>

<!-- ===== B) BARRA DE FILTROS RAPIDOS ===== -->
<div class="quick-filters-bar">
  <div class="quick-filters-left">
    <app-periodo-dropdown
      [quickDateFilter]="quickDateFilter"
      [filtroInicio]="filtro.inicio"
      [filtroFim]="filtro.fim"
      (periodoAlterado)="onPeriodoAlterado($event)">
    </app-periodo-dropdown>
  </div>
  <div class="quick-filters-right">
    <button class="btn-filtros" [class.active]="mostrarFiltrosAvancados" (click)="toggleFiltrosAvancados()">
      <i class="fe-sliders mr-1"></i> Filtros
      <i class="fe-chevron-up ml-1" *ngIf="mostrarFiltrosAvancados"></i>
      <i class="fe-chevron-down ml-1" *ngIf="!mostrarFiltrosAvancados"></i>
    </button>
  </div>
</div>

<!-- ===== C) PAINEL DE FILTROS ===== -->
<div class="filtros-panel" *ngIf="mostrarFiltrosAvancados">
  <!-- Status -->
  <div class="filtro-group">
    <label class="filtro-label">STATUS</label>
    <div class="filtro-pills">
      <label class="checkbox-pill" [class.checked]="filtro.pagos">
        <input type="checkbox" [(ngModel)]="filtro.pagos" (ngModelChange)="carregueResumoVendas()"/>
        <span>Pagos</span>
      </label>
      <label class="checkbox-pill" [class.checked]="filtro.naoPagos">
        <input type="checkbox" [(ngModel)]="filtro.naoPagos" (ngModelChange)="carregueResumoVendas()"/>
        <span>Não pagos</span>
      </label>
    </div>
  </div>

  <!-- Tipo de Pedido -->
  <div class="filtro-group" *ngIf="!this.balcao">
    <label class="filtro-label">TIPO DE PEDIDO</label>
    <div class="filtro-pills">
      <label class="checkbox-pill" [class.checked]="filtro.delivery">
        <input type="checkbox" [(ngModel)]="filtro.delivery" (ngModelChange)="carregueResumoVendas()"/>
        <span>Delivery</span>
      </label>
      <label class="checkbox-pill" [class.checked]="filtro.mesa">
        <input type="checkbox" [(ngModel)]="filtro.mesa" (ngModelChange)="carregueResumoVendas()"/>
        <span>Mesa</span>
      </label>
      <label class="checkbox-pill" [class.checked]="filtro.balcao" *ngIf="!empresa.integracaoDelivery">
        <input type="checkbox" [(ngModel)]="filtro.balcao" (ngModelChange)="carregueResumoVendas()"/>
        <span>Balcão</span>
      </label>
    </div>
  </div>

  <!-- Forma de Pagamento -->
  <div class="filtro-group">
    <label class="filtro-label">FORMA DE PAGAMENTO</label>
    <kendo-multiselect [(ngModel)]="filtro.formasDePagamento" [data]="empresa.formasDePagamento"
                       placeholder="Todas" class="filtro-select"
                       textField="descricao" valueField="id"
                       (ngModelChange)="carregueResumoVendas()">
    </kendo-multiselect>
  </div>

  <!-- Cupons -->
  <div class="filtro-group" *ngIf="cupons.length">
    <label class="filtro-label">CUPONS</label>
    <kendo-multiselect [(ngModel)]="filtro.cupons" [data]="cupons"
                       placeholder="Todos" class="filtro-select"
                       textField="codigo" valueField="id"
                       (ngModelChange)="carregueResumoVendas()">
    </kendo-multiselect>
  </div>

  <!-- Rede -->
  <div class="filtro-group" *ngIf="redes.length">
    <label class="filtro-label">REDE</label>
    <kendo-combobox [(ngModel)]="filtro.rede" [data]="redes"
                    placeholder="Todas" class="filtro-select" [textField]="'nome'"
                    (ngModelChange)="carregueResumoVendas()">
    </kendo-combobox>
  </div>

  <!-- Formas de entrega -->
  <div class="filtro-group" *ngIf="!balcao">
    <label class="filtro-label">FORMA DE ENTREGA</label>
    <kendo-combobox [(ngModel)]="filtro.formaDeEntregaEmpresa" [data]="empresa.formasDeEntrega"
                    placeholder="Todas" class="filtro-select" [textField]="'nome'"
                    (ngModelChange)="carregueResumoVendas()">
    </kendo-combobox>
  </div>

  <!-- Garcons -->
  <div class="filtro-group" *ngIf="garcons.length && filtro.mesa">
    <label class="filtro-label">GARÇONS</label>
    <kendo-multiselect [(ngModel)]="filtro.garcons" [data]="garcons"
                       placeholder="Todos" class="filtro-select"
                       textField="nome" valueField="id"
                       (ngModelChange)="carregueResumoVendas()">
    </kendo-multiselect>
  </div>

  <!-- Promocoes -->
  <div class="filtro-group" *ngIf="promocoes.length">
    <label class="filtro-label">PROMOÇÕES</label>
    <kendo-multiselect [(ngModel)]="filtro.promocoes" [data]="promocoes"
                       placeholder="Todas" class="filtro-select"
                       textField="descricao" valueField="id"
                       (ngModelChange)="carregueResumoVendas()">
    </kendo-multiselect>
  </div>
</div>

<!-- ===== D) CARDS DE RESUMO ===== -->
<div class="summary-cards-container">
  <div class="summary-card card-blue" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card-top">
      <span class="card-label">Total de vendas</span>
      <i class="fe-trending-up card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.totalComTaxa | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-blue" *ngIf="resumoVendas.totalPagamentosComTaxa && (resumoVendas.totalComTaxa != resumoVendas.totalPagamentosComTaxa)">
    <div class="card-top">
      <span class="card-label">Total pagamentos</span>
      <i class="fe-trending-up card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.totalPagamentosComTaxa | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-green" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card-top">
      <span class="card-label">Valor líquido</span>
      <i class="fe-check card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.total | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-orange" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card-top">
      <span class="card-label">Taxas de entrega</span>
      <i class="fe-truck card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.taxaDeEntrega | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-purple">
    <div class="card-top">
      <span class="card-label">Pedidos</span>
      <i class="fe-shopping-bag card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.qtde | number}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-teal" *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
    <div class="card-top">
      <span class="card-label">Ticket médio</span>
      <i class="fe-bar-chart card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.ticketMedio | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>
</div>

<!-- ===== E) GRAFICO DE EVOLUCAO DE VENDAS ===== -->
<div class="chart-container" *ngIf="chartLabels.length > 1">
  <div class="card">
    <div class="card-body">
      <div class="chart-header">
        <div>
          <h5 class="chart-title">Evolução de vendas</h5>
          <p class="chart-subtitle">{{obtenhaDescricaoFiltro()}}</p>
        </div>
        <div class="chart-legend">
          <span class="legend-item"><span class="legend-dot legend-blue"></span> Dias úteis</span>
          <span class="legend-item"><span class="legend-dot legend-orange"></span> Fim de semana</span>
        </div>
      </div>

      <kendo-chart [style.height.px]="300">
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item [categories]="chartLabels">
            <kendo-chart-category-axis-item-labels [rotation]="0" [font]="'11px sans-serif'" [color]="'#94a3b8'">
            </kendo-chart-category-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>

        <kendo-chart-value-axis>
          <kendo-chart-value-axis-item>
            <kendo-chart-value-axis-item-labels format="c0" [font]="'11px sans-serif'" [color]="'#94a3b8'">
            </kendo-chart-value-axis-item-labels>
          </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>

        <kendo-chart-series>
          <kendo-chart-series-item
            [data]="chartDiasUteis"
            [type]="'column'"
            name="Dias úteis"
            color="#3B82F6"
            [gap]="0.5"
            [spacing]="0">
            <kendo-chart-series-item-tooltip>
              <ng-template let-value="value" let-category="category">
                <div *ngIf="value">{{category}}: {{value | currency: "BRL"}}</div>
              </ng-template>
            </kendo-chart-series-item-tooltip>
          </kendo-chart-series-item>

          <kendo-chart-series-item
            [data]="chartFimSemana"
            [type]="'column'"
            name="Fim de semana"
            color="#F97316"
            [gap]="0.5"
            [spacing]="0">
            <kendo-chart-series-item-tooltip>
              <ng-template let-value="value" let-category="category">
                <div *ngIf="value">{{category}}: {{value | currency: "BRL"}}</div>
              </ng-template>
            </kendo-chart-series-item-tooltip>
          </kendo-chart-series-item>
        </kendo-chart-series>

        <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      </kendo-chart>
    </div>
  </div>
</div>

<!-- ===== F) TABS DE DETALHAMENTO ===== -->
<div class="card" [hidden]="vendasDoDia || vendasProduto">
  <div class="card-body">
    <kendo-tabstrip #tabVendas class="nav-bordered" (tabSelect)="selecionouTab($event)">

      <!-- Tab: Por loja -->
      <kendo-tabstrip-tab [title]="'Por loja'" [id]="'loja'" *ngIf="rede" [selected]="rede">
        <ng-template kendoTabContent>
          <h5>Vendas por loja <b>{{obtenhaDescricaoFiltro()}}</b></h5>
          <kendo-grid [data]="vendasLojasResultSet" [loading]="carregando" style="min-height: 300px;"
                      [sortable]="{mode: 'single'}" [sort]="sortLoja" (sortChange)="sortChangeLojas($event)">
            <ng-template kendoGridToolbarTemplate>
              <button type="button" kendoGridExcelCommand icon="file-excel">Exportar</button>
            </ng-template>
            <kendo-grid-column title="Cod. Loja" field="codigoLoja" [width]="150">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-dark">{{resumo.codigoLoja}}</span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Loja" field="nomeLoja">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-dark">{{resumo.nomeLoja}}</span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde Pedidos" field="qtde" [width]="150">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde | number}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="totalComTaxa" [width]="250">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-success"><b>{{resumo.totalComTaxa | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Taxa de Entrega">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-success"><b>{{resumo.totalTaxaDeEntrega | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Ticket médio">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-muted"><b>{{resumo.ticketMedio | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('lojas')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Vendas diarias -->
      <kendo-tabstrip-tab [title]="'Vendas diárias'" [id]="'vendas'" [selected]="!rede">
        <ng-template kendoTabContent>
          <div class="tab-header">
            <h5>Vendas diárias {{obtenhaDescricaoFiltro()}}</h5>
          </div>
          <kendo-grid [kendoGridBinding]="resumoVendas.diarias" [loading]="carregando" style="min-height: 300px;">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma venda no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm" kendoGridExcelCommand icon="file-excel">Exportar</button>
              </div>
            </ng-template>
            <kendo-grid-column title="Dia" field="dia" [width]="150">
              <ng-template kendoGridCellTemplate let-resumoDia><span class="text-dark">{{resumoDia.dia}}</span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde Pedidos" field="qtde" [width]="150">
              <ng-template kendoGridCellTemplate let-resumoDia><b class="text-primary">{{resumoDia.qtde | number}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="totalComTaxa" [width]="250"
                               *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-success"><b>{{resumoDia.totalComTaxa | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total pagamentos" field="totalPagamentosComTaxa" [width]="250"
                               *ngIf="resumoVendas.totalPagamentosComTaxa && (resumoVendas.totalComTaxa !== resumoVendas.totalPagamentosComTaxa)">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-success"><b>{{resumoDia.totalPagamentosComTaxa | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Taxa de Entrega" field="totalTaxaDeEntrega"
                               *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-danger"><b>{{resumoDia.totalTaxaDeEntrega | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Valor Líquido" field="total"
                               *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-success"><b>{{(resumoDia.total) | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Ticket médio" field="ticketMedio"
                               *ngIf="!resumoVendas.totalPagamentosComTaxa || (resumoVendas.totalComTaxa === resumoVendas.totalPagamentosComTaxa)">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-muted"><b>{{resumoDia.ticketMedio | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="80">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <button class="btn btn-outline-blue btn-sm" (click)="verPedidos(resumoDia)" title="ver pedidos" kendoTooltip>
                  <i class="fe-list fa-lg"></i>
                </button>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-diarias')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Por Produtos -->
      <kendo-tabstrip-tab [title]="'Por Produtos'" [id]="'produtos'">
        <ng-template kendoTabContent>
          <h5>Produtos vendidos {{obtenhaDescricaoFiltro()}}
            <div class="ml-2 form-group d-inline-block">
              <input type="checkbox" id="porAdicionais" name="porAdicionais" class="k-checkbox" kendoCheckBox
                     [(ngModel)]="filtro.porAdicionais" (ngModelChange)="carregueResumoProdutos()"/>
              <label class="k-checkbox-label" for="porAdicionais">Exibir vendas dos adicionais</label>
            </div>
          </h5>
          <kendo-grid [kendoGridBinding]="resumoProdutos.produtos" [loading]="resumoProdutos.carregando"
                      [groupable]="true" [group]="group">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma produto vendido no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm" kendoGridExcelCommand icon="file-excel">Exportar</button>
                <button class="btn btn-outline-secondary btn-sm ml-1" *ngIf="!filtro.porAdicionais" kendoTooltip
                        title="exportar produtos/contatos csv" (click)="downloadCsvProdutos()">
                  <i class="fa fa-download fa-lg"></i> Exportar vendas/contato
                </button>
              </div>
            </ng-template>
            <kendo-grid-column title="Codigo" field="codigo" [width]="100">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <span class="text-blue"><b>{{resumoProduto.codigo}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Produto" field="nome">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <span class="text-dark">{{resumoProduto.nome}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde vendido" field="qtdeDescricao" [width]="250">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <b>{{resumoProduto.qtdeDescricao}}</b>
              </ng-template>
              <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                <span> Qtde vendido: {{ aggregates.qtde.sum | number }} </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="total" [width]="250">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <span class="text-success"><b>{{resumoProduto.total | currency: "BRL"}}</b></span>
              </ng-template>
              <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                <ng-container *ngIf="resumoProdutos.totalDescontos">
                  <label> Total produtos: <span class="text-success"> +{{ aggregates.total.sum | currency: 'BRL'}}</span> </label>
                  <label> Total descontos: <span class="text-danger"> -{{ resumoProdutos.totalDescontos | currency: 'BRL'}}</span></label>
                </ng-container>
                <label> Total: <span class="text-success"><b>{{ (aggregates.total.sum - resumoProdutos.totalDescontos) | currency: 'BRL'}}</b></span></label>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="!filtro.porAdicionais">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <button class="btn btn-outline-blue btn-sm ml-1" (click)="verDetalhesVendasProduto(resumoProduto)" title="ver detalhes" kendoTooltip>
                  <i class="fe-list fa-lg"></i>
                </button>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload(filtro.porAdicionais ? 'vendas-adicionais' : 'vendas-produtos')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Combinacoes -->
      <kendo-tabstrip-tab [title]="'Combinações'" [id]="'combinacoesProdutos'">
        <ng-template kendoTabContent>
          <h5>Combinações de adicionais {{obtenhaDescricaoFiltro()}}</h5>
          <div class="mb-2">
            <span class="mr-3"><b>Qtde total:</b> {{resumoCombinacoes.qtdeTotal | number}}</span>
            <span><b>Total adicionais:</b> {{resumoCombinacoes.totalAdicionais | currency: "BRL"}}</span>
          </div>
          <kendo-grid [kendoGridBinding]="resumoCombinacoes.combinacoes" [loading]="resumoCombinacoes.carregando" style="min-height: 300">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma combinação no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm" kendoGridExcelCommand icon="file-excel">Exportar</button>
              </div>
            </ng-template>
            <kendo-grid-column title="Produto" field="produto" [width]="250">
              <ng-template kendoGridCellTemplate let-c><span class="text-dark">{{c.produto}}</span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Descrição" field="descricaoCombinacao">
              <ng-template kendoGridCellTemplate let-c>
                <span class="text-dark">{{c.descricaoCombinacao}}</span>
                <span class="badge badge-secondary ml-2" *ngIf="c.semAdicionais">Sem adicionais</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde" field="qtde" [width]="150">
              <ng-template kendoGridCellTemplate let-c><b>{{c.qtde | number}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total" field="totalAdicionais" [width]="250">
              <ng-template kendoGridCellTemplate let-c><span class="text-success"><b>{{c.totalAdicionais | currency: "BRL"}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoCombinacoesGeral()"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Por Cupons -->
      <kendo-tabstrip-tab [title]="'Por Cupons'" [id]="'cupons'">
        <ng-template kendoTabContent>
          <h5>Cupons utilizados {{obtenhaDescricaoFiltro()}}</h5>
          <kendo-grid [data]="vendasCuponsResultSet" [loading]="resumoCupons.carregando"
                      [sortable]="{ allowUnsort: false, mode:'single' }" [sort]="sortCupom" (sortChange)="sortChange($event)">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma venda no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm ml-1" kendoGridExcelCommand icon="file-excel">Exportar</button>
                <button class="btn btn-outline-secondary btn-sm ml-1" *ngIf="rede" kendoTooltip title="exportar cupons/loja" (click)="downloadCsvCupons()">
                  <i class="fa fa-download fa-lg mr-1"></i> Exportar por lojas
                </button>
                <button class="btn btn-outline-secondary btn-sm ml-1" kendoTooltip title="exportar cupons/contatos" (click)="downloadCsvCuponsContatos()">
                  <i class="fa fa-download fa-lg mr-1"></i> Exportar por contatos
                </button>
              </div>
            </ng-template>
            <kendo-grid-column title="Cupom" field="codigo">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-blue"><b>{{resumo.codigo}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde vendido" field="qtde" [width]="250">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde}}</b></ng-template>
              <ng-template kendoGridFooterTemplate>
                <ng-container *ngIf="this.resumoVendas.cupons.length">{{ totalCupons['qtde'].sum }}</ng-container>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" [width]="150" field="total">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.total | currency: "BRL"}}</b></span></ng-template>
              <ng-template kendoGridFooterTemplate>
                <ng-container *ngIf="this.resumoVendas.cupons.length">{{ totalCupons['total'].sum | currency: "BRL"}}</ng-container>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total descontos" [width]="150" field="totalDesconto">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.totalDesconto | currency: "BRL"}}</b></span></ng-template>
              <ng-template kendoGridFooterTemplate>
                <ng-container *ngIf="this.resumoVendas.cupons.length">{{ totalCupons['totalDesconto'].sum | currency: "BRL"}}</ng-container>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column></kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-cupons')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Por Promocoes -->
      <kendo-tabstrip-tab [title]="'Por Promoções'" [id]="'promocoes'">
        <ng-template kendoTabContent>
          <h5>Promoções utilizadas {{obtenhaDescricaoFiltro()}}</h5>
          <kendo-grid [data]="vendasPromocoesResultSet" [loading]="resumoPromocoes.carregando"
                      [sortable]="{ allowUnsort: false, mode:'single' }" [sort]="sortCupom" (sortChange)="sortChange($event)">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma venda no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm ml-1" kendoGridExcelCommand icon="file-excel">Exportar</button>
                <button class="btn btn-outline-secondary btn-sm ml-1" *ngIf="rede" kendoTooltip title="exportar promoções/loja" (click)="downloadCsvPromocoes()">
                  <i class="fa fa-download fa-lg mr-1"></i> Exportar por lojas
                </button>
                <button class="btn btn-outline-secondary btn-sm ml-1" kendoTooltip title="exportar promoções/contatos" (click)="downloadCsvPromocoesContatos()">
                  <i class="fa fa-download fa-lg mr-1"></i> Exportar por contatos
                </button>
              </div>
            </ng-template>
            <kendo-grid-column title="Promoção" field="descricao">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-blue"><b>{{resumo.descricao}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde vendido" field="qtde" [width]="250">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde}}</b></ng-template>
              <ng-template kendoGridFooterTemplate>
                <ng-container *ngIf="this.resumoVendas.promocoes.length">{{ totalPromocoes['qtde'].sum }}</ng-container>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" [width]="150" field="total">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.total | currency: "BRL"}}</b></span></ng-template>
              <ng-template kendoGridFooterTemplate>
                <ng-container *ngIf="this.resumoVendas.promocoes.length">{{ totalPromocoes['total'].sum | currency: "BRL"}}</ng-container>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total descontos" [width]="150" field="totalDesconto">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.totalDesconto | currency: "BRL"}}</b></span></ng-template>
              <ng-template kendoGridFooterTemplate>
                <ng-container *ngIf="this.resumoVendas.promocoes.length">{{ totalPromocoes['totalDesconto'].sum | currency: "BRL"}}</ng-container>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column></kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-promocoes')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Por Formas de Pagamento -->
      <kendo-tabstrip-tab [title]="'Por Formas de Pagamento'" [id]="'formas'">
        <ng-template kendoTabContent>
          <h5>Formas de pagamento <b>{{obtenhaDescricaoFiltro()}}</b></h5>
          <kendo-grid [kendoGridBinding]="resumoPorFormasPagamento" [loading]="carregandoResumoFormaPagamento">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma venda no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm" kendoGridExcelCommand icon="file-excel">Exportar</button>
              </div>
            </ng-template>
            <kendo-grid-column title="Forma" field="nome">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-blue"><b>{{resumo.nome}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde vendido" field="qtde" [width]="250">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" [width]="150" field="total">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.total | currency: "BRL"}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column></kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-formas-pagamento')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Por Formas Entrega -->
      <kendo-tabstrip-tab [title]="'Por Formas de Entrega'" [id]="'formasEntrega'" *ngIf="!balcao">
        <ng-template kendoTabContent>
          <h5>Formas de entrega <b>{{obtenhaDescricaoFiltro()}}</b></h5>
          <kendo-grid [data]="resumoVendas.formasDeEntrega" [loading]="carregando">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma venda no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm" kendoGridExcelCommand icon="file-excel">Exportar</button>
              </div>
            </ng-template>
            <kendo-grid-column title="Forma" field="nome">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-blue"><b>{{resumo.nome}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde vendido" field="qtde" [width]="250">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" [width]="150" field="total">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.total | currency: "BRL"}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column></kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-formas-entrega')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- Tab: Por Garcom -->
      <kendo-tabstrip-tab [title]="'Por Garçom'" [id]="'garcons'" *ngIf="filtro.mesa">
        <ng-template kendoTabContent>
          <h5>Vendas por garçom <b>{{obtenhaDescricaoFiltro()}}</b></h5>
          <kendo-grid [kendoGridBinding]="resumoGarcons.garcons" [loading]="resumoGarcons.carregando" style="min-height: 300px;">
            <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
              noRecords="nenhuma venda no período" loading="Carregando" pagerItemsPerPage="ítems por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <div class="float-right">
                <button type="button" class="btn btn-outline-secondary btn-sm" kendoGridExcelCommand icon="file-excel">Exportar</button>
              </div>
            </ng-template>
            <kendo-grid-column title="Garçom" field="garcom">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-dark"><b>{{resumo.garcom}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde Pedidos" field="qtde" [width]="150">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde | number}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="total" [width]="250">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-success"><b>{{resumo.total | currency: "BRL"}}</b></span></ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-garcons')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

    </kendo-tabstrip>
  </div>
</div>

<!-- ===== G) DRILL-DOWN: Pedidos do dia ===== -->
<ng-container *ngIf="vendasDoDia">
  <h4>
    <button class="btn btn-outline-blue btn-rounded" (click)="voltarVendasDia()">
      <i class="fa fa-arrow-left ct-point"></i>
    </button>
    Vendas do dia <span><b>{{vendasDoDia.dia}}</b></span>
  </h4>
  <app-grid-pedidos #gridPedidos [pedidos]="vendasDoDia.pedidos" [carregando]="vendasDoDia.carregando" [mesa]="false"></app-grid-pedidos>
</ng-container>

<!-- ===== G) DRILL-DOWN: Detalhes do produto ===== -->
<ng-container *ngIf="vendasProduto">
  <h4>
    <button class="btn btn-outline-blue btn-rounded" (click)="voltarVendasProdutos()">
      <i class="fa fa-arrow-left ct-point"></i>
    </button>
    Vendas do produto <span><b>{{vendasProduto.nome}}</b></span>
  </h4>
  <kendo-tabstrip class="nav-bordered mt-3" (tabSelect)="selecionouTabDetalheProduto($event)">
    <kendo-tabstrip-tab [title]="'Adicionais'" [selected]="vendasProdutoAbaAtiva === 'adicionais'">
      <ng-template kendoTabContent>
        <h5 class="mt-2">Vendas dos adicionais {{obtenhaDescricaoFiltro()}}</h5>
        <kendo-grid [kendoGridBinding]="vendasProduto.adicionais" [loading]="carregandoAdicionaisProduto" style="min-height: 300">
          <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
            noRecords="nenhum adicional" loading="Carregando" pagerItemsPerPage="ítems por página">
          </kendo-grid-messages>
          <ng-template kendoGridToolbarTemplate>
            <button type="button" class="float-right" kendoGridExcelCommand icon="file-excel">Exportar para Excel</button>
          </ng-template>
          <kendo-grid-column title="produto" field="produto" [width]="250">
            <ng-template kendoGridCellTemplate let-r><span class="text-dark">{{r.produto}}</span></ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Adicional" field="nome">
            <ng-template kendoGridCellTemplate let-r><span class="text-dark">{{r.nome}}</span></ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Qtde" [width]="150" field="qtde">
            <ng-template kendoGridCellTemplate let-r><b>{{r.qtde | number}}</b></ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Total" [width]="250" field="total">
            <ng-template kendoGridCellTemplate let-r><span class="text-success"><b>{{r.total | currency: "BRL"}}</b></span></ng-template>
          </kendo-grid-column>
          <kendo-grid-excel [fileName]="obtenhaNomeArquivo()"></kendo-grid-excel>
        </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'Combinações'" [selected]="vendasProdutoAbaAtiva === 'combinacoes'">
      <ng-template kendoTabContent>
        <h5 class="mt-2">Combinações de adicionais {{obtenhaDescricaoFiltro()}}</h5>
        <div class="mb-2">
          <span class="mr-3"><b>Qtde total:</b> {{resumoCombinacoesProduto.qtdeTotal | number}}</span>
          <span><b>Total adicionais:</b> {{resumoCombinacoesProduto.totalAdicionais | currency: "BRL"}}</span>
        </div>
        <kendo-grid [kendoGridBinding]="resumoCombinacoesProduto.combinacoes" [loading]="carregandoCombinacoesProduto" style="min-height: 300">
          <kendo-grid-messages pagerPage="Página" pagerOf="de" pagerItems="itens"
            noRecords="nenhuma combinação no período" loading="Carregando" pagerItemsPerPage="ítems por página">
          </kendo-grid-messages>
          <ng-template kendoGridToolbarTemplate>
            <button type="button" class="float-right" kendoGridExcelCommand icon="file-excel">Exportar para Excel</button>
          </ng-template>
          <kendo-grid-column title="Produto" field="produto" [width]="250">
            <ng-template kendoGridCellTemplate let-c><span class="text-dark">{{c.produto}}</span></ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Descrição" field="descricaoCombinacao">
            <ng-template kendoGridCellTemplate let-c>
              <span class="text-dark">{{c.descricaoCombinacao}}</span>
              <span class="badge badge-secondary ml-2" *ngIf="c.semAdicionais">Sem adicionais</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Qtde" field="qtde" [width]="150">
            <ng-template kendoGridCellTemplate let-c><b>{{c.qtde | number}}</b></ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Total" field="totalAdicionais" [width]="250">
            <ng-template kendoGridCellTemplate let-c><span class="text-success"><b>{{c.totalAdicionais | currency: "BRL"}}</b></span></ng-template>
          </kendo-grid-column>
          <kendo-grid-excel [fileName]="obtenhaNomeArquivoCombinacoes()"></kendo-grid-excel>
        </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</ng-container>
